import { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

export const ImageUpload = ({ onUploaded, label = "Upload Image", testId = "upload-btn", multiple = false }) => {
  const ref = useRef();
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setLoading(true);
    let ok = 0;
    for (const file of files) {
      try {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        onUploaded(data.url);
        ok++;
      } catch {
        toast.error(`Upload failed: ${file.name}`);
      }
    }
    if (ok) toast.success(`${ok} image${ok > 1 ? "s" : ""} uploaded`);
    setLoading(false);
    if (ref.current) ref.current.value = "";
  };

  return (
    <>
      <input ref={ref} type="file" accept="image/png,image/jpeg,image/gif,image/webp" multiple={multiple} onChange={handle} className="hidden" data-testid={`${testId}-input`} />
      <button type="button" onClick={() => ref.current?.click()} disabled={loading} data-testid={testId}
        className="inline-flex items-center gap-2 border border-zinc-700 text-xs font-bold uppercase tracking-widest px-4 py-2 hover:border-white transition-colors disabled:opacity-50 whitespace-nowrap">
        {loading ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />} {label}
      </button>
    </>
  );
};
